import React, { useState } from "react";

interface ImageGalleryProps {
  title: string;
  previewImages: string[];
  onImageClick?: (image: string) => void; // Hacerlo opcional

}

const ImageGallery: React.FC<ImageGalleryProps> = ({ title, previewImages,onImageClick  }) => {
  const [activeImage, setActiveImage] = useState(previewImages[0]);

  const handleImageClick = (image: string) => {
    setActiveImage(image);
    onImageClick?.(image); // Llamar la función solo si existe
  };
  
  return (
    <div className="lg:sticky lg:top-8 lg:h-[calc(100vh-4rem)] lg:overflow-y-auto scrollbar-hidden space-y-8">
      {/* Imagen principal */}
      <div className="relative group">
        <img
          src={activeImage}
          alt={`${title} preview`}
          className="w-full rounded-xl shadow-2xl object-contain h-[200px] lg:h-[400px] transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-900/30 to-transparent rounded-xl" />
      </div>

      {/* Miniaturas */}
      <div className="flex space-x-4 overflow-x-auto pb-4 scrollbar-hide">
        {previewImages.map((image, index) => (
          <div 
            key={index}
            className="relative flex-shrink-0 cursor-pointer group"
            onClick={() => handleImageClick(image)}
          >
            <img
              src={image}
              alt={`${title} thumbnail ${index + 1}`}
              className={`w-24 h-24 rounded-lg object-contain scrollbar-hidden transition-all duration-300 ${
                activeImage === image 
                  ? 'ring-4 ring-navy-900 ring-offset-2' 
                  : 'opacity-75 hover:opacity-100 hover:scale-105'
              }`}
            />
            {activeImage === image && (
              <div className="absolute inset-0 bg-navy-900/20 rounded-lg" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageGallery;
